var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7eufbgf0ya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.125 31.583 41.667 59.041 26.708 44.125 20.835 50l20.833 20.833L75 37.5l-5.875-5.917zM50 8.333C27 8.333 8.334 27 8.334 50S27 91.666 50 91.666C73 91.666 91.667 73 91.667 50 91.667 27 73 8.333 50 8.333zm0 75c-18.416 0-33.333-14.917-33.333-33.333 0-18.417 14.916-33.334 33.333-33.334 18.417 0 33.334 14.917 33.334 33.334 0 18.416-14.917 33.333-33.334 33.333z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7eufbgf0ya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
};
export default SvgCheck;